<template>
  <div class="ads-analyzer">
    <div class="dialog-holder" v-if="visibleDialog" v-bind:class="'dialog-holder-' + visibleDialog">
      <div class="dialog mdl-card mdl-shadow--4dp ">
        <div class="mdl-card__title mdl-color--primary" >
          <h2 class="mdl-card__title-text">{{ i18n().dialog[visibleDialog].title }}</h2>
          <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                  @click="closeDialog"><i class="material-icons">close</i></button>
        </div>
        <div v-if="visibleDialog == 'saveView'">
          <SaveView contentType="ads-view" v-bind:data="saveableView" @close="closeDialog"></SaveView>
        </div>
        <div v-if="visibleDialog == 'loadView'">
          <LoadView contentType="ads-view" @close="closeDialog" @load="loadView"></LoadView>
        </div>
      </div>
    </div>

    <div class="stats" v-if="inputTable != null">
      <div class="stat-head">
        <div class="stat-title-bar">

          <h4>{{ inputTable.title }} <span v-if="inputTable.fileName">[{{ i18n().filename + inputTable.fileName }}]</span></h4>

          <div class="export-buttons">
            <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                    v-on:click="saveCSV">
              <i class="material-icons">archive</i> {{ i18n().saveCSV }}
            </button>
            <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                    v-on:click="saveTSV">
              <i class="material-icons">archive</i> {{ i18n().saveTSV }}
            </button>
            <LoadFileSmall @file="file => $emit('file', file)">></LoadFileSmall>
          </div>

        </div>
        <div class="stat-prompt-panel" v-if="tips.length > 0">
          <div class="mdl-card mdl-shadow--2dp">
            <div class="mdl-card__title mdl-color--primary">

              <button v-if="tipsExpanded" v-on:click="() => tipsVisible = false"
                      class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent">
                <i class="material-icons">expand_less</i></button>
              <button v-if="!tipsExpanded" v-on:click="() => tipsVisible = true"
                      class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent">
                <i class="material-icons">expand_more</i></button>

              <h2 class="mdl-card__title-text">{{ i18n().tips }}</h2>

            </div>

            <div v-if="tipsExpanded">
              <div class="prompt mdl-card__supporting-text" v-for="(tip, tipId) in tips" v-bind:class="tip.name">
                <p>
                  {{ tip.text }}
                </p>
                <button
                  v-if="tip.filter"
                  class="mdl-button mdl-js-button mdl-button--raised mdl-button--accent"
                  v-on:click="showTip(tip)">
                  {{ i18n().tipApplyFilter }}
                </button>
              </div>
            </div>

          </div>
        </div>

        <div class="statTopBarHolder">

          <TopBar
            :query.sync="query" :inputColumnNames="inputTable && inputTable.columnNames"
            :calculatedColumnNames="calculatedTable && calculatedTable.columnNames"
            :categories="categories"
            :filter.sync="filter" :appliedFilter="appliedFilter"
            :enableFilter.sync="enableFilter" :filterExpanded.sync="filterExpanded"
            :tips="tips" :tipsExpanded.sync="tipsExpanded"
            @showTip="showTip"
            @save="openSaveViewDialog" @load="openLoadViewDialog"
            @applyFilter="applyFilter" @updateFilter="updateFilter" @clearFilter="clearFilter"></TopBar>

        </div>

      </div>
      <div class="stat-lower">

        <AdsLeftBar :filter.sync="filter" :appliedFilter="appliedFilter" :query.sync="query"
                    :categories="categories" :enableFilter.sync="enableFilter"
                    :inputColumnNames="inputTable && inputTable.columnNames"
                    :calculatedColumnNames="calculatedTable && calculatedTable.columnNames"
                    @save="openSaveViewDialog" @load="openLoadViewDialog"
                    @applyFilter="applyFilter" @updateFilter="updateFilter" @clearFilter="clearFilter"></AdsLeftBar>

        <div class="stat-content">

          <div class="loading-holder" v-if="state == 'computing' || state == 'filtering'">
            <h3>{{ i18n()[state].title }}</h3>
            <div id="p2" class="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
            <h4>{{ i18n()[state].text }}</h4>
          </div>


          <div class="loading-holder" v-if="state == 'done' && limitedVisibleTable.rows.length == 0">
            <h3>{{ i18n().empty }}</h3>
          </div>

          <div class="loading-holder" v-if="state == 'failed'">
            <h3>{{ i18n().failed }}</h3>
          </div>

          <div class="error-holder" v-if="state == 'wrongType'">
            <h3>{{ i18n().wrongType.title }}</h3>
            <p>{{ i18n().wrongType.text }}</p>
          </div>

          <div class="table-space" v-if="limitedVisibleTable && limitedVisibleTable.rows.length > 0">
            <AdsTable :table="limitedVisibleTable" :sortColumn="sortColumn" :sortAsc="sortAsc"
                      :rowHeight="query.aggregateUrls ? 111 : 91" :firstColumnWidth="650"
                      @toggleSort="toggleSort" :endInfo="tableEndInfo"></AdsTable><!-- :found="found" -->
          </div>

        </div>

      </div>

    </div>

    <div class="testSettings" v-if="testEnvironment">
      <b>Test Settings:</b>
      <div><label for="maxRows">maxRows:</label><input type="text" v-model="maxVisibleRows" id="maxRows"></div>
    </div>
  </div>
</template>

<script>
  import LoadFileSmall from "./utils/LoadFileSmall"
  import BigTable from "./utils/BigTable"
  import AdsTable from "./ads/AdsTable"
  import SaveView from "./save/SaveView.vue"
  import LoadView from "./save/LoadView.vue"
  import AdsLeftBar from "./ads/AdsLeftBar.vue"
  import TopBar from "./query/TopBar.vue"

  import WorkerQueue from "../io/WorkerQueue"
  import expression from "../logic/expression"
  import adsAnalyzer from "../logic/adsAnalyzer"
  import adsAnalyzerWorker from 'worker-loader!../logic/adsAnalyzer'
  window.analyzerWorker = adsAnalyzerWorker
  import { parseCSV, generateCSV } from "../io/csv"
  import { saveBlob } from "../io/save"
  import i18n from "i18n"

  import config from "../config"
  import Vue from "vue"
  import logger from "../logger"

  import api from "../api"
  import overlayModel from "./utils/overlayModel.js"
  import PremiumOverlay from "./premium/PremiumOverlay.vue"

  const webWorkerQueue = new WorkerQueue(adsAnalyzerWorker)

  const adsAnalyzerState = new Vue({
    data: {
      filter: JSON.parse(JSON.stringify(config.logic.defaultFilter)),
      sortColumn: "Count",
      sortAsc: false,
      appliedFilter: null,
      query: JSON.parse(JSON.stringify(config.logic.ads.defaultQuery)),
    }
  })

  export default {
    name: 'ads-analyzer',
    props: {
      inputTable: {
        type: Object,
        default() {
          return null
        }
      },
      searchText: {
        type: String
      }
    },
    components: {
      LoadFileSmall,
      BigTable,
      AdsTable,
      SaveView,
      LoadView,
      AdsLeftBar,
      TopBar
    },
    metaInfo: {
      title: 'Ads'
    },
    data() {
      return {
        query: JSON.parse(JSON.stringify(config.logic.ads.defaultQuery)),
        outputTable: null,
        calculatedTable: null,
        visibleTable: null,
        state: "ready",
        sortColumn: adsAnalyzerState.sortColumn,
        sortAsc: adsAnalyzerState.sortAsc,
        filter: adsAnalyzerState.filter,
        appliedFilter: adsAnalyzerState.appliedFilter,
        webWorkerEnabled: localStorage.noWorker ? false : typeof(Worker) !== "undefined",
        categories: null,
        lastSearchChange: 0,
        visibleDialog: null,
        tips: [],
        tipsExpanded: true,
        filterExpanded: true,
        enableFilter: false,
        maxVisibleRows: config.view.maxVisibleRows,
        testEnvironment: localStorage.test
      }
    },
    computed: {
      viewSettings() {
        return {
          sortBy: this.sortColumn,
          sortAsc: this.sortAsc,
          filter: this.appliedFilter,
          enableFilter: true,
          searchText: this.searchText,
          maxVisibleRows: this.maxVisibleRows
        }
      },
      visibleDialogTitle() {
        switch(this.visibleDialog) {
          case 'loadView' : return "Load ilters"
          case 'saveView' : return "Save Filters"
          default: 'Dialog?!'
        }
      },
      saveableView() {
        return {
          sortColumn: this.sortColumn,
          sortAsc: this.sortAsc,
          filter: this.appliedFilter || this.filter,
          filterApplied: !!this.appliedFilter
        }
      },
      limitedVisibleTable() {
        const viewSettings = this.viewSettings
        const visibleTable = this.visibleTable
        if(!visibleTable) return null
        return {
          ...visibleTable,
          rows: visibleTable.rows.slice(0, (+viewSettings.maxVisibleRows) || config.view.maxVisibleRows)
        }
      },
      premium() {
        return api.session.premium
      },
      tableEndInfoType() {
        if(this.visibleTable.rows.length == this.limitedVisibleTable.rows.length) return null
        if(!this.premium) return "premium"
        return "download"
      },
      tableEndInfo() {
        const type = this.tableEndInfoType
        if(!type) return null
        return {
          text: i18n().endInfo[type]({
            allRows: this.visibleTable.rows.length,
            visibleRows: this.limitedVisibleTable.rows.length
          }),
          type
        }
      }
    },
    watch: {
      enableFilter(v) {
        if(!v && this.appliedFilter) this.clearFilter()
      },
      inputTable(table) {
        this.processInputTable(table)
      },
      query(v) {
        adsAnalyzerState.query = v
        this.computeOutputTable()
      },
      filter(v) {adsAnalyzerState.filter= v },
      appliedFilter(v) {adsAnalyzerState.appliedFilter = v },
      sortColumn(v) {adsAnalyzerState.sortColumn = v },
      sortAsc(v) {adsAnalyzerState.sortAsc = v },
      outputTable() {
        this.computeCalculatedTable()
      },
      calculatedTable() {
        this.computeVisibleTable()
        this.computeTips()
      },
      viewSettings() {
        this.computeVisibleTable()
      }
    },
    methods: {
      showPremiumOverlay() {
        overlayModel.show({
          component: PremiumOverlay,
          props: {
          },
          on: {}
        })
      },
      i18n() {
        return i18n().ads
      },
      doWorkerTask(method, args) {
        logger.startLagDetector('ads-'+method, 1000)
        let promise
        if (this.webWorkerEnabled) {
          promise = webWorkerQueue.doWorkerTask(method, args)
        } else {
          promise = new Promise((resolve, reject) => {
            args = JSON.parse(JSON.stringify(args))
            resolve(adsAnalyzer[method](...args))
          })
        }
        return promise.then(result => {
          logger.stopLagDetector('ads-'+method)
          return result
        }).catch(error => {
          logger.stopLagDetector('ads-'+method)
          logger.addTag('ads-error','ads-'+method+"-error")
          throw error
        })
      },
      processInputTable(table) {
        console.log("INPUT TABLE", table)
        if(table.type != "adPerformance") {
          this.state = "wrongType"
          return;
        }
        this.computeCategories()
        this.computeOutputTable()
      },
      cellText(cell) {
        if(typeof cell == "number") return this.addThousandSeparator((cell % 100) == 0 ? cell / 100 : (cell / 100).toFixed(2))
        return cell
      },
      addThousandSeparator(nStr) {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + '\u00A0' + '$2');
        }
        return x1 + x2;
      },
      toggleSort(columnName) {
        if(columnName == this.sortColumn) {
          this.sortAsc = !this.sortAsc
        } else {
          this.sortColumn = columnName
        }
      },
      saveCSV() {
        if(!this.premium) return this.showPremiumOverlay()
        const table = this.visibleTable
        const data = generateCSV({
          ...table,
          columnNames: table.displayColumnNames
        }, ',', this.cellText)
        const blob = new Blob([data], {type: 'text/csv'})
        const filename = table.title.replace(/[^\u00BF-\u1FFF\u2C00-\uD7FF\w)(\.-]/g, ' ') + ".csv"
        saveBlob(blob, filename)
      },
      saveTSV() {
        if(!this.premium) return this.showPremiumOverlay()
        const table = this.visibleTable
        const data = generateCSV({
          ...table,
          columnNames: table.displayColumnNames
        }, '\t', this.cellText)
        const blob = new Blob([data], {type: 'text/tsv'})
        const filename = table.title.replace(/[^\u00BF-\u1FFF\u2C00-\uD7FF\w)(\.-]/g, ' ') + ".tsv"
        saveBlob(blob, filename)
      },
      applyFilter() {
        const filterJson = JSON.stringify(this.filter)
        console.log("APPLY FILTER", filterJson)
        this.appliedFilter = JSON.parse(filterJson)
      },
      updateFilter() {
        const filterJson = JSON.stringify(this.filter)
        console.log("UPDATE FILTER", filterJson)
        this.appliedFilter = JSON.parse(filterJson)
      },
      clearFilter() {
        this.appliedFilter = null
      },
      computeCategories() {
        const inputTable = this.inputTable
        if (!inputTable) return this.categories = null
        this.state = "computing"
        this.categories = null
        return this.doWorkerTask("findCategories", [inputTable]).then(
          result => this.categories = result
        )
      },
      computeOutputTable() {
        const inputTable = this.inputTable
        if(!inputTable) return null
        this.state = "computing"
        this.outputTable = null
        return this.doWorkerTask("preformAnalysis", [inputTable, this.query]).then(
          result => this.outputTable = result
        )
      },
      computeCalculatedTable() {
        const outputTable = this.outputTable
        if (!outputTable) return this.calculatedTable = null
        this.state = "computing"
        this.calculatedTable = null
        return this.doWorkerTask("calculateTable", [outputTable]).then(
          result => this.calculatedTable = result
        )
      },
      computeVisibleTable() {
        const calculatedTable = this.calculatedTable
        const viewSettings = this.viewSettings
        if (!calculatedTable) return this.visibleTable = null
        this.state = "filtering"
        this.visibleTable = null
        return this.doWorkerTask("prepareTableView", [calculatedTable, viewSettings]).then(
          result => {
            result.displayColumnNames = i18n().translateColumnNames(result.columnNames)
            this.visibleTable = result
            this.state = result ? "done" : "failed"
          }
        )
      },
      computeTips() {
        const inputTable = this.inputTable
        const outputTable = this.calculatedTable
        this.tips = []
        return this.doWorkerTask("generateTips", [inputTable, outputTable]).then(
          result => {
            this.tips = result
          }
        )
      },
      openSaveViewDialog() {
        this.visibleDialog = "saveView"
      },
      openLoadViewDialog() {
        this.visibleDialog = "loadView"
      },
      closeDialog() {
        this.visibleDialog = null
      },
      loadView(view) {
        console.log("LOAD view", view)
        this.filter = view.filter
        if(view.filterApplied) this.appliedFilter = this.filter
        this.sortColumn = view.sortColumn
        this.sortAsc = view.sortAsc
      },
      showTip(tip) {
        if(tip.filter) {
          this.filter = tip.filter
          this.enableFilter = true
          this.applyFilter()
        }
      }
    },
    created () {
      this.processInputTable(this.inputTable)
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    },
    beforeDestroy() {
    }
  }

</script>

<style scoped>

  .stats {
    position: absolute;
    top: 4em;
    bottom: 0em;
    height: auto;
    left: 1em;
    right: 0em;
    width: auto;
    display: flex;
    flex-direction: column;
  }

  .stats > .stat-head {
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
  }

  .stat-head > .stat-title-bar {
    display: flex;
    flex-direction: row;
  }

  .stat-title-bar > h4 {
    flex-grow: 1;
    flex-shrink: 1;
    flex: 5;
  }
  .stat-title-bar > .export-buttons {
    position: relative;
    padding-top: 1.23em;
    flex-shrink: 0;
    flex-grow: 0;
    width: 18em;
    margin-right: 1em;
    display: block;
    text-align: center;
  }
  .stat-title-bar > .export-buttons button {
    position: relative;
    display: inline-block;
    margin: 0.23em;
    float: right;
    max-width: 7em;
    padding-left: 0.66em;
    padding-right: 0.66em;
  }

  .stat-prompt-panel {
    flex-grow: 0;
    flex-shrink: 0;
    position: relative;
  }

  .stat-prompt-panel > .mdl-card {
    width: auto;
    box-sizing: border-box;
    margin-right: 1em;
    margin-bottom: 1em;
    min-height: 0;
    position: relative;
  }

  .stat-prompt-panel .mdl-card__title  > button {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 0px;
    margin-right: 12px;
    flex-grow: 0;
  }

  .prompt {
    display: flex;
    flex-direction: row;
    padding: 4px 12px;
    width: auto;
    align-items: center;
    border-top: 1px solid darkgrey;
  }
  .prompt:nth-child(2) {
    border-top: none;
  }
  .prompt button {
    flex-shrink: 0;
    flex-grow: 0;
  }
  .prompt > p {
    flex-grow: 1;
    font-size: 1.23em;
    margin: 0;
  }

  .stats > .stat-lower {
    flex-grow: 1;
    flex-shrink: 1;
    position: relative;
  }


  .stat-content {
    position: absolute;
    left: 17em;
    right: 0em;
    top: 0em;
    bottom: 0em;
    width: auto;
    height: auto;
  }

  .stats .table-space {
    position: absolute;
    right: 0em;
    left: 0em;
    width: auto;
    top: 0em;
    bottom: 0em;
    height: auto;
  }

  .stats .loading-holder {
    position: absolute;
    right: 0em;
    left: 0em;
    width: auto;
    top: 0em;
    bottom: 0em;
    height: auto;
    text-align: center;
  }

  .stats .error-holder {
    position: absolute;
    right: 0em;
    left: 0em;
    width: auto;
    top: 0em;
    bottom: 0em;
    height: auto;
    text-align: center;
  }

  .stats .loading-holder .mdl-progress {
    margin-left: auto;
    margin-right: auto;
  }

  .stats .info-holder {
    position: absolute;
    right: 3em;
    left: 19em;
    width: auto;
    top: 10em;
    bottom: 0em;
    height: auto;
    text-align: center;
  }


  @media screen and (max-width: 1024px) {
    .mdl-layout__header {
      display: block;
    }
  }


  .dialog-holder {
    z-index: 10;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
  }
  .dialog-holder .mdl-card__title button {
    display: block;
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-right: 0px;
    float: right;
  }
  .dialog-holder .mdl-card__title button > i {
    font-size: 20px;
  }
  .dialog {
    margin-left: auto;
    margin-right: auto;
  }
  .dialog-holder a {
  }
  .dialog-holder-saveView .dialog {
    width: 500px;
    max-width: 100%;
    max-height: 100%;
  }
  .dialog-holder-loadView .dialog {
    width: 500px;
    max-width: 100%;
    max-height: 100%;
  }

  .testSettings {
    position: absolute;
    left: 100px;
    top: 0px;
    width: 300px;
    height: 100px;
    border: 1px solid black;
    background: cornsilk;
    padding: 5px;
  }
  .testSettings label {
    display: inline-block;
    text-align: right;
    width: 120px;
    padding-right: 5px;
  }
  .testSettings input {
    width: 160px;
  }

</style>




// WEBPACK FOOTER //
// AdsAnalyzer.vue?d16aec46